export const STEP_LOGIN = 'STEP_LOGIN';
export const STEP_ERROR = 'STEP_ERROR';
export const STEP_ERROR_NOT_ELIGIBLE = 'STEP_ERROR_NOT_ELIGIBLE';
export const STEP_CHECK_AUTHENTICATION = 'STEP_CHECK_AUTHENTICATION';
export const STEP_GET_FRIENDS_REFERRAL_INFO = 'STEP_GET_FRIENDS_REFERRAL_INFO';
export const STEP_INVITEE_PAGE = 'STEP_INVITEE_PAGE';
export const STEP_INVITATION_PAGE = 'STEP_INVITATION_PAGE';
export const STEP_CHECK_INVITATION = 'STEP_CHECK_INVITATION';
export const STEP_REFERRAL_DASHBOARD = 'STEP_REFERRAL_DASHBOARD';
export const STEP_PLATFORM_REGISTER = 'STEP_PLATFORM_REGISTER';
export const STEP_CHECK_STATUS = 'STEP_CHECK_STATUS';
export const STEP_ERROR_STATUS = 'STEP_ERROR_STATUS';
export const STEP_ERROR_MAINTENANCE = 'STEP_ERROR_MAINTENANCE';
export const STEP_UBISERVICES_REQUEST_ERROR = 'STEP_UBISERVICES_REQUEST_ERROR';
export const STEP_ERROR_NOT_LINKED = 'STEP_ERROR_NOT_LINKED';
export const STEP_CHECK_FRIENDS_REFERRAL_INFO = 'STEP_CHECK_FRIENDS_REFERRAL_INFO';
export const STEP_END_OF_OPERATION = 'STEP_END_OF_OPERATION';
